export const SN_ORDER = 'transferorder'
export const ORDER_CURRENT_UPDATED = SN_ORDER + '/CURRENT_UPDATED'
export const ORDER_TRANSFER_QUERY_UPDATED = SN_ORDER + '/TRANSFER_QUERY_UPDATED'
export const ORDER_TRANSFER_UPDATED = SN_ORDER + '/TRANSFER_UPDATED'
export const ORDER_TRANSFER_LIST_CLEARED = SN_ORDER + '/TRANSFER_LIST_CLEARED'
export const ORDER_TRANSFER_QUERY_CLEARED = SN_ORDER + '/TRANSFER_QUERY_CLEARED'
export const ORDER_CURRENT_CLEARED = SN_ORDER + '/CURRENT_ORDER_CLEARED'
export const ORDER_CURRENT_PRODUCT_ADDED = SN_ORDER + '/CURRENT_PRODUCT_ADDED'
export const ORDER_MISSHIPPED_ITEMS_UPDATED = SN_ORDER + '/MISSHIPPED_ITEMS_UPDATED'